import React from 'react';
import { ExceptionLinkAction, ExceptionReference } from '@/redux/slices/slice_types';
import DrawerActionButton from '@/components/Exceptions/ActionButtons/DrawerActionButton';
import { getActionButtonLabel } from '@/components/Exceptions/utils/utils';

interface LinkActionButtonProps {
  action: ExceptionLinkAction;
  references: ExceptionReference[];
}

const DrawerLinkActionButton: React.FC<LinkActionButtonProps> = ({ action, references }) => {
  const label = getActionButtonLabel(action, references);
  return <DrawerActionButton isLink label={label} url={action.detail.url} />;
};

export default DrawerLinkActionButton;
